import { Box, Drawer } from "@mui/material";
import ApplicationRecordsList from "./List";
import ApplicationRecordsListFilter from "./ListFilter";
import { BasePathProvider } from "components/Providers";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { setSearchApplicationQuery } from "store/application/student-applications";
import ApplicationDetailIndex from "./Profile";

export default function ApplicationRecordsListPage({ clientSchools, gradeLevel, types, academicYears }) {
    const baseUrl = '/admission'
    const navigate = useNavigate();
    const { applicationId } = useParams();
    const dispatch = useDispatch();
    const query = useSelector(state => state.application.studentApplications.query);

    const [queryReady, setQueryReady] = useState(false);
    useEffect(() => {
        if (queryReady || !academicYears?.length) return;
        if (!query?.yearApp) {
            const latest = academicYears.reduce((newest, year) =>
                (dayjs(year.startDate).isAfter(newest.startDate) ? year : newest));
            dispatch(setSearchApplicationQuery({ ...query, yearApp: latest.yearApp }));
        }
        setQueryReady(true);
    }, [academicYears, queryReady]);

    return (
        <BasePathProvider value={`${baseUrl}/application-list/`}>
            <Box sx={{  backgroundColor: 'background.paper', borderRadius: 2, boxShadow: 1, p: 2, my: 1, gap: 2, display: 'flex', flexDirection: 'column' }}>
                <ApplicationRecordsListFilter clientSchools={clientSchools} gradeLevel={gradeLevel} types={types} academicYears={academicYears} />
                <ApplicationRecordsList queryReady={queryReady} />
            </Box>
            <Drawer
                anchor="right"
                open={Boolean(applicationId)}
                onClose={() => navigate(`${baseUrl}/application-list`)}
                PaperProps={{
                    sx: {
                        minWidth: { xs: '100%', md: '60%' },
                        maxWidth: { xs: '100%', md: '60%' }
                    }
                }}
            >
                <ApplicationDetailIndex clientSchools={clientSchools} academicYears={academicYears} />
            </Drawer>
        </BasePathProvider>

    );
}